import { render, staticRenderFns } from "./PanelOrganizer.vue?vue&type=template&id=40b43e76&scoped=true&"
import script from "./PanelOrganizer.vue?vue&type=script&lang=js&"
export * from "./PanelOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./PanelOrganizer.vue?vue&type=style&index=0&id=40b43e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b43e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b43e76')) {
      api.createRecord('40b43e76', component.options)
    } else {
      api.reload('40b43e76', component.options)
    }
    module.hot.accept("./PanelOrganizer.vue?vue&type=template&id=40b43e76&scoped=true&", function () {
      api.rerender('40b43e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelOrganizer.vue"
export default component.exports